import { render } from "./AppMenuComponent.vue?vue&type=template&id=0f4845ea&scoped=true"
import script from "./AppMenuComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenuComponent.vue?vue&type=script&setup=true&lang=js"

import "./AppMenuComponent.vue?vue&type=style&index=0&id=0f4845ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4845ea"],['__file',"src/core/layout/AppMenuComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f4845ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f4845ea', __exports__)) {
    console.log('reload')
    api.reload('0f4845ea', __exports__)
  }
  
  module.hot.accept("./AppMenuComponent.vue?vue&type=template&id=0f4845ea&scoped=true", () => {
    console.log('re-render')
    api.rerender('0f4845ea', render)
  })

}


export default __exports__